import 安徽 from './map/安徽.json';
import 甘肃 from './map/甘肃.json';
import 广西 from './map/广西.json';
import 贵州 from './map/贵州.json';
import 河北 from './map/河北.json';
import 河南 from './map/河南.json';
import 湖北 from './map/湖北.json';
import 湖南 from './map/湖南.json';
import 吉林 from './map/吉林.json';
import 江西 from './map/江西.json';
import 辽宁 from './map/辽宁.json';
import 山西 from './map/山西.json';
import 四川 from './map/四川.json';
import 西藏 from './map/西藏.json';
import 新疆 from './map/新疆.json';
import 云南 from './map/云南.json';

import 宜春市 from './map/江西省/宜春市.json';
import 丰城市 from './map/江西省/宜春市/丰城市.json';
import 奉新县 from './map/江西省/宜春市/奉新县.json';
import 高安市 from './map/江西省/宜春市/高安市.json';
import 靖安县 from './map/江西省/宜春市/靖安县.json';
import 上高县 from './map/江西省/宜春市/上高县.json';
import 铜鼓县 from './map/江西省/宜春市/铜鼓县.json';
import 万载县 from './map/江西省/宜春市/万载县.json';
import 宜丰县 from './map/江西省/宜春市/宜丰县.json';
import 袁州区 from './map/江西省/宜春市/袁州区.json';
import 樟树市 from './map/江西省/宜春市/樟树市.json';

import 抚州市 from './map/江西省/抚州市.json';
import 崇仁县 from './map/江西省/抚州市/崇仁县.json';
import 东乡区 from './map/江西省/抚州市/东乡区.json';
import 广昌县 from './map/江西省/抚州市/广昌县.json';
import 金溪县 from './map/江西省/抚州市/金溪县.json';
import 乐安县 from './map/江西省/抚州市/乐安县.json';
import 黎川县 from './map/江西省/抚州市/黎川县.json';
import 临川区 from './map/江西省/抚州市/临川区.json';
import 南城县 from './map/江西省/抚州市/南城县.json';
import 南丰县 from './map/江西省/抚州市/南丰县.json';
import 宜黄县 from './map/江西省/抚州市/宜黄县.json';
import 资溪县 from './map/江西省/抚州市/资溪县.json';

import 赣州市 from './map/江西省/赣州市.json';
import 安远县 from './map/江西省/赣州市/安远县.json';
import 崇义县 from './map/江西省/赣州市/崇义县.json';
import 大余县 from './map/江西省/赣州市/大余县.json';
import 定南县 from './map/江西省/赣州市/定南县.json';
import 赣县区 from './map/江西省/赣州市/赣县区.json';
import 会昌县 from './map/江西省/赣州市/会昌县.json';
import 龙南市 from './map/江西省/赣州市/龙南市.json';
import 南康区 from './map/江西省/赣州市/南康区.json';
import 宁都县 from './map/江西省/赣州市/宁都县.json';
import 全南县 from './map/江西省/赣州市/全南县.json';
import 瑞金市 from './map/江西省/赣州市/瑞金市.json';
import 上犹县 from './map/江西省/赣州市/上犹县.json';
import 石城县 from './map/江西省/赣州市/石城县.json';
import 信丰县 from './map/江西省/赣州市/信丰县.json';
import 兴国县 from './map/江西省/赣州市/兴国县.json';
import 寻乌县 from './map/江西省/赣州市/寻乌县.json';
import 于都县 from './map/江西省/赣州市/于都县.json';

import 吉安市 from './map/江西省/吉安市.json';
import 安福县 from './map/江西省/吉安市/安福县.json';
import 吉安县 from './map/江西省/吉安市/吉安县.json';
import 吉水县 from './map/江西省/吉安市/吉水县.json';
import 吉州区 from './map/江西省/吉安市/吉州区.json';
import 井冈山市 from './map/江西省/吉安市/井冈山市.json';
import 青原区 from './map/江西省/吉安市/青原区.json';
import 遂川县 from './map/江西省/吉安市/遂川县.json';
import 泰和县 from './map/江西省/吉安市/泰和县.json';
import 万安县 from './map/江西省/吉安市/万安县.json';
import 峡江县 from './map/江西省/吉安市/峡江县.json';
import 新干县 from './map/江西省/吉安市/新干县.json';
import 永丰县 from './map/江西省/吉安市/永丰县.json';
import 永新县 from './map/江西省/吉安市/永新县.json';

import 景德镇市 from './map/江西省/景德镇市.json';
import 昌江区 from './map/江西省/景德镇市/昌江区.json';
import 浮梁县 from './map/江西省/景德镇市/浮梁县.json';
import 乐平市 from './map/江西省/景德镇市/乐平市.json';
import 珠山区 from './map/江西省/景德镇市/珠山区.json';

import 九江市 from './map/江西省/九江市.json';
import 柴桑区 from './map/江西省/九江市/柴桑区.json';
import 德安县 from './map/江西省/九江市/德安县.json';
import 都昌县 from './map/江西省/九江市/都昌县.json';
import 共青城市 from './map/江西省/九江市/共青城市.json';
import 湖口县 from './map/江西省/九江市/湖口县.json';
import 濂溪区 from './map/江西省/九江市/濂溪区.json';
import 庐山市 from './map/江西省/九江市/庐山市.json';
import 彭泽县 from './map/江西省/九江市/彭泽县.json';
import 瑞昌市 from './map/江西省/九江市/瑞昌市.json';
import 武宁县 from './map/江西省/九江市/武宁县.json';
import 修水县 from './map/江西省/九江市/修水县.json';
import 浔阳区 from './map/江西省/九江市/浔阳区.json';
import 永修县 from './map/江西省/九江市/永修县.json';

import 南昌市 from './map/江西省/南昌市.json';
import 安义县 from './map/江西省/南昌市/安义县.json';
import 东湖区 from './map/江西省/南昌市/东湖区.json';
import 进贤县 from './map/江西省/南昌市/进贤县.json';
import 南昌县 from './map/江西省/南昌市/南昌县.json';
import 西湖区 from './map/江西省/南昌市/西湖区.json';
import 新建区 from './map/江西省/南昌市/新建区.json';
import 红谷滩区 from './map/江西省/南昌市/红谷滩区.json';
import 青山湖区 from './map/江西省/南昌市/青山湖区.json';
import 青云谱区 from './map/江西省/南昌市/青云谱区.json';

import 萍乡市 from './map/江西省/萍乡市.json';
import 安源区 from './map/江西省/萍乡市/安源区.json';
import 莲花县 from './map/江西省/萍乡市/莲花县.json';
import 芦溪县 from './map/江西省/萍乡市/芦溪县.json';
import 上栗县 from './map/江西省/萍乡市/上栗县.json';
import 湘东区 from './map/江西省/萍乡市/湘东区.json';

import 上饶市 from './map/江西省/上饶市.json';
import 德兴市 from './map/江西省/上饶市/德兴市.json';
import 广丰区 from './map/江西省/上饶市/广丰区.json';
import 广信区 from './map/江西省/上饶市/广信区.json';
import 横峰县 from './map/江西省/上饶市/横峰县.json';
import 鄱阳县 from './map/江西省/上饶市/鄱阳县.json';
import 铅山县 from './map/江西省/上饶市/铅山县.json';
import 万年县 from './map/江西省/上饶市/万年县.json';
import 婺源县 from './map/江西省/上饶市/婺源县.json';
import 信州区 from './map/江西省/上饶市/信州区.json';
import 弋阳县 from './map/江西省/上饶市/弋阳县.json';
import 余干县 from './map/江西省/上饶市/余干县.json';
import 玉山县 from './map/江西省/上饶市/玉山县.json';

import 新余市 from './map/江西省/新余市.json';
import 分宜县 from './map/江西省/新余市/分宜县.json';
import 渝水区 from './map/江西省/新余市/渝水区.json';

import 鹰潭市 from './map/江西省/鹰潭市.json';
import 贵溪市 from './map/江西省/鹰潭市/贵溪市.json';
import 余江区 from './map/江西省/鹰潭市/余江区.json';
import 月湖区 from './map/江西省/鹰潭市/月湖区.json';

const allCity = {
  河北,
  山西,
  辽宁,
  吉林,
  安徽,
  江西,
  河南,
  湖北,
  湖南,
  广西,
  四川,
  贵州,
  云南,
  西藏,
  甘肃,
  新疆,

  宜春市,
  丰城市,
  奉新县,
  高安市,
  靖安县,
  上高县,
  铜鼓县,
  万载县,
  宜丰县,
  袁州区,
  樟树市,

  抚州市,
  崇仁县,
  东乡区,
  广昌县,
  金溪县,
  乐安县,
  黎川县,
  临川区,
  南城县,
  南丰县,
  宜黄县,
  资溪县,

  赣州市,
  安远县,
  崇义县,
  大余县,
  定南县,
  赣县区,
  会昌县,
  龙南市,
  南康区,
  宁都县,
  全南县,
  瑞金市,
  上犹县,
  石城县,
  信丰县,
  兴国县,
  寻乌县,
  于都县,

  吉安市,
  安福县,
  吉安县,
  吉水县,
  吉州区,
  井冈山市,
  青原区,
  遂川县,
  泰和县,
  万安县,
  峡江县,
  新干县,
  永丰县,
  永新县,

  景德镇市,
  昌江区,
  浮梁县,
  乐平市,
  珠山区,

  九江市,
  柴桑区,
  德安县,
  都昌县,
  共青城市,
  湖口县,
  濂溪区,
  庐山市,
  彭泽县,
  瑞昌市,
  武宁县,
  修水县,
  浔阳区,
  永修县,

  南昌市,
  安义县,
  东湖区,
  进贤县,
  南昌县,
  西湖区,
  新建区,
  红谷滩区,
  青山湖区,
  青云谱区,

  萍乡市,
  安源区,
  莲花县,
  芦溪县,
  上栗县,
  湘东区,

  上饶市,
  德兴市,
  广丰区,
  广信区,
  横峰县,
  鄱阳县,
  铅山县,
  万年县,
  婺源县,
  信州区,
  弋阳县,
  余干县,
  玉山县,

  新余市,
  分宜县,
  渝水区,

  鹰潭市,
  贵溪市,
  余江区,
  月湖区,
};
const allCityPy = {
  中国: 'zhongguo',
  河北: 'hebei',
  山西: 'shangxi',
  辽宁: 'liaoning',
  吉林: 'jilin',
  安徽: 'anhui',
  江西: 'jiangxi',
  河南: 'henan',
  湖北: 'hubei',
  湖南: 'hunan',
  广西: 'guangxi',
  四川: 'sichuan',
  贵州: 'guizhou',
  云南: 'yunnan',
  西藏: 'xizang',
  甘肃: 'gansu',
  新疆: 'xinjiang',
  宜春市: 'yichunshi',
  丰城市: 'fengchengshi',
  奉新县: 'fengxinxian',
  高安市: 'gaoanshi',
  靖安县: 'jinganxian',
  上高县: 'shanggaoxian',
  铜鼓县: 'tongguxian',
  万载县: 'wanzaixian',
  宜丰县: 'yifengxian',
  袁州区: 'yuanzhouqu',
  樟树市: 'zhangshushi',

  抚州市: 'fuzhoushi',
  崇仁县: 'chongrenxian',
  东乡区: 'dongxiangqu',
  广昌县: 'guangchangxian',
  金溪县: 'jinxixian',
  乐安县: 'leanxian',
  黎川县: 'lichuanxian',
  临川区: 'linchuanqu',
  南城县: 'nanchengxian',
  南丰县: 'nanfengxian',
  宜黄县: 'yihuangxian',
  资溪县: 'zixixian',

  赣州市: 'ganzhoushi',
  安远县: 'anyuanxian',
  崇义县: 'chongyixian',
  大余县: 'dayudian',
  定南县: 'dingnanxian',
  赣县区: 'ganxianqu',
  会昌县: 'huichangxian',
  龙南市: 'longnanshi',
  南康区: 'nankangqu',
  宁都县: 'ningduxian',
  全南县: 'quannanxian',
  瑞金市: 'ruijinshi',
  上犹县: 'shangyouxian',
  石城县: 'shichengxian',
  信丰县: 'xinfengxian',
  兴国县: 'xingguoxian',
  寻乌县: 'xunwuxian',
  于都县: 'yuduxian',

  吉安市: 'jianshi',
  安福县: 'anfuxian',
  吉安县: 'jianxian',
  吉水县: 'jishuixian',
  吉州区: 'jizhouqu',
  井冈山市: 'jinggangshanshi',
  青原区: 'qingyuanqu',
  遂川县: 'suichuanxian',
  泰和县: 'taihexian',
  万安县: 'wananxian',
  峡江县: 'xiajiangxian',
  新干县: 'xinganxian',
  永丰县: 'yongfengxian',
  永新县: 'yongxinxian',

  景德镇市: 'jingdezhenshi',
  昌江区: 'changjiangqu',
  浮梁县: 'fuliangxian',
  乐平市: 'lepingshi',
  珠山区: 'zhushanqu',

  九江市: 'jiujiangshi',
  柴桑区: 'chaisangqu',
  德安县: 'deanxian',
  都昌县: 'duchangxian',
  共青城市: 'gongqingchengshi',
  湖口县: 'hukouxian',
  濂溪区: 'lianxiqu',
  庐山市: 'lushanshi',
  彭泽县: 'pengzenxian',
  瑞昌市: 'ruichangshi',
  武宁县: 'wuningxian',
  修水县: 'xiushuixian',
  浔阳区: 'xunyangqu',
  永修县: 'yongxiuxian',

  南昌市: 'nanchangshi',
  安义县: 'anyixian',
  东湖区: 'donghuqu',
  进贤县: 'jinxianxian',
  南昌县: 'nanchangxian',
  西湖区: 'xihuqu',
  新建区: 'xinjianqu',
  红谷滩区: 'honggutanqu',
  青山湖区: 'qingshanhuqu',
  青云谱区: 'qingyunpuqu',

  萍乡市: 'pingxiangshi',
  安源区: 'anyuanqu',
  莲花县: 'lianhuaxian',
  芦溪县: 'luxixian',
  上栗县: 'shanglixian',
  湘东区: 'xiangdongqu',

  上饶市: 'shangraoshi',
  德兴市: 'dexingshi',
  广丰区: 'guangfengqu',
  广信区: 'guangxinqu',
  横峰县: 'hengfengxian',
  鄱阳县: 'poyangxian',
  铅山县: 'yanshanxian',
  万年县: 'wannianxian',
  婺源县: 'wuyuanxian',
  信州区: 'xinzhouqu',
  弋阳县: 'yiyangxian',
  余干县: 'yuganxian',
  玉山县: 'yushanxian',

  新余市: 'yuxinshi',
  分宜县: 'fenyixian',
  渝水区: 'yushuiqu',

  鹰潭市: 'yingtanshi',
  贵溪市: 'guixishi',
  余江区: 'yujiangqu',
  月湖区: 'yuehuqu',
};
export { allCity, allCityPy };
